import { Modal } from 'react-bootstrap';

export const customsValueModal = ({ subTitle, animation, size, show, onHide, showButtons, onConfirm, header }) => {
  return (
    <Modal centered size={size} animation={animation} show={show} onHide={onHide}>
      <Modal.Header>
        <Modal.Title>{header}</Modal.Title>
        <button type="button" class="btn-close" aria-label="Close" onClick={onHide} />
      </Modal.Header>
      <Modal.Body>
        <span>{subTitle}</span>
      </Modal.Body>
      <Modal.Footer
        class="py-3 px-3"
        style={{
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
        }}
      >
        <div className="push-left-right">
          <button
            class="blue-button-newload green"
            onClick={(event) => {
              onHide(event);
            }}
            style={{ display: showButtons ? 'flex' : 'none', borderRadius: '10px' }}
          >
            {' '}
            Cancel
          </button>

          <button
            class="blue-button-newload"
            onClick={(event) => {
              onConfirm();
              onHide(event);
            }}
            style={{ display: showButtons ? 'flex' : 'none', borderRadius: '10px' }}
          >
            Adjustments
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default customsValueModal;
